import { useTranslation } from 'react-i18next';



import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie"; 
import LocalManager from "../../../class/LocalManager";
/* import loadingGif from "../static/img/loading-slider-3.png";
import loadingGifpromo from "../static/img/loadingpromo.png"; */
import StaticPromo from "./StaticPromo";


const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

function SliderV1({ sliderType, isLogged, handleOpenRegisterModal, lang }) {
  const { t } = useTranslation();
  const [sliderData, setSliderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingPromo, setLoadingPromo] = useState(true);


  const [css_col, setcssCol] = useState('col-7');

  const [custom_class, setCustomClass] = useState('');
  const [error, setError] = useState(null); 
  const [selectedLanguage, setSelectedLanguage] = useState(null); // Вибрана мова
  const carouselRef = useRef(null);

  const slide = {
    slides: [
      {
        img: "/assets/img/carousel1.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 1,
      },
      {
        img: "/assets/img/carousel2.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 2,
      },
      {
        img: "/assets/img/carousel3.jpg",
        inputs: [
          { lang_code: "zh", sub_title: "", title: "" },
          { lang_code: "en", sub_title: "", title: "" },
          { lang_code: "de", sub_title: "", title: "" },
          { lang_code: "it", sub_title: "", title: "" },
          { lang_code: "es", sub_title: "", title: "" },
        ],
        link: null,
        position: 3,
      },
    ],
    type: "Home",
  };

  useEffect(() => {
    const savedLanguage = Cookies.get("lang");
    setSelectedLanguage(savedLanguage); 
  }, [lang]);

  useEffect(() => {
    const fetchSliderData = async () => {
      if(sliderType == "Home"){
        setCustomClass("slider-home-v1");
      }else{
        setCustomClass("slider-casino-v1");
        setcssCol("col-8");
      }
      setLoading(true);
      try {
        // const data = await LocalManager.getSlider(sliderType);

        // if (data.status) {
        //   data.slider.slides.shift();       
        //   console.log(data.slider);   
        //   console.log(data.slider.slides.shift());   
        //   setSliderData(data.slider);
        // } else {
        //   setError(data.error || t('Failed_to_load_slider'));
        // }

        setSliderData(slide);

      } catch (err) {
        console.error("Fetch error:", err);
        setError(t('Unexpected_response_format_or_server_error'));
      } finally {
       setLoading(false);
      }
    };

    fetchSliderData();
    setLoadingPromo(false);

    // Симулюємо завантаження промо-блоків
    // caricamento posticipato tolto
    // setTimeout(() => {
    //   setLoadingPromo(false);
    // }, 2000);
  }, [sliderType, lang]);

  

  useEffect(() => {
    if (carouselRef.current && sliderData) {
      const bootstrap = require("bootstrap");
      new bootstrap.Carousel(carouselRef.current, {
        interval: 8000,
        ride: "carousel",
      });
    }
  }, [sliderData]);

  // **Гіфка-завантажувач для слайдера**
  const SliderLoader = () => (
    <div style={{ width: "100%", height: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      
      <img src={`/assets/img/loading-slider-3.png?ts=${new Date().getTime()}`} alt="Loading..." style={{ width: "100%" }} />
    </div>
  );

  // **Гіфка-завантажувач для промо-блоків**
  const PromoLoader = () => (
    <div style={{ width: "100%", height: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <img src={`/assets/img/loadingpromo.png?ts=${new Date().getTime()}`} alt="Loading..." style={{ width: "100%" }} />
      
    </div>
  );
  

  return (

    <>
   
    
    <div className={`container-fluid ${custom_class}`}>
      <div className="row">
        
        <div  className={`${css_col}`} style={{ minHeight: "300px" }}> 
          {loading ? (
            <SliderLoader />
          ) : (
            <div id="carouselHomeControls" className="carousel slide big-slider" ref={carouselRef}>
              <div className="carousel-inner">
                {sliderData.slides
                  .sort((a, b) => a.position - b.position)
                  .map((slide, index) => (
                    <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                      <img
                        src={`${slide.img}`}
                        // src={`${cmsUrl}${slide.img}`}
                        className="d-block w-100"
                        alt={`Slide ${index + 1}`}
                      />
                      <div className="text-slider" style={{display:"none"}}>
                        {slide.inputs
                          .filter((input) => input.lang_code === lang)
                          .map((input, inputIndex) => (
                            <div key={inputIndex}>
                              <h2 className="shadow-dance-tex">{input.title}</h2>
                              <p>{input.sub_title}</p>
                            </div>
                          ))}
                        {/* <div className="bt-slide">
                          {index === 0 && !isLogged && (
                            <a
                              href="#"
                              className="btn btn-sm btn-registration"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenRegisterModal();
                              }}
                            >
                              {t('Sign_up')}
                            </a>
                          )}
                          {slide.link && (
                            <a
                              href={slide.link}
                              className="btn btn-sm btn-more"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {t('Discover')}
                            </a>
                          )}
                        </div> */}
                      </div>
                    </div> 
                  ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselHomeControls"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">{t('Previous')}</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselHomeControls"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">{t('Next')}</span>
              </button>
            </div>
          )}
        </div>

        
        <div className="col" style={{ minHeight: "300px" }}>
          {loadingPromo ? (
            <PromoLoader />
          ) : (
            <StaticPromo
              img_url={`/assets/img/slider1.jpg`}
              title="Lighthing Roulette"
              subtitle="Gioca ora"
              handleOpenRegisterModal={handleOpenRegisterModal}
              isLogged={isLogged}
            />
          )}
        </div>

        
        {sliderType !== "Casino" && (
          <div className="col" style={{ minHeight: "300px" }}>
            {loadingPromo ? (
              <PromoLoader />
            ) : (
              <StaticPromo
                img_url={`/assets/img/slider2.jpg`}
                title="Crazy Time"
                subtitle="Gioca ora"
                handleOpenRegisterModal={handleOpenRegisterModal}
                isLogged={isLogged}
              />
            )}
          </div>
        )}
      </div>
    </div>
    </>

  );
}

export default SliderV1;







